import { render } from "./StoreSectionCard.vue?vue&type=template&id=6d69588c&scoped=true"
const script = {}

import "./StoreSectionCard.vue?vue&type=style&index=0&id=6d69588c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d69588c"]])

export default __exports__